import { cva } from 'class-variance-authority';

import type { VariantProps } from 'class-variance-authority';

import s from './TagTime.module.css';

const tagTimeVariants = cva(s.wrapper, {
  defaultVariants: {
    color: 'default',
    size: 'base',
  },
  variants: {
    color: {
      accent: s.c_accent,
      default: s.c_default,
    },
    size: {
      base: s.s_base,
    },
  },
});

type TagTimeVariantsProps = VariantProps<typeof tagTimeVariants>;

export { tagTimeVariants, type TagTimeVariantsProps };
